import React from 'react';
import { FaInstagram } from 'react-icons/fa';
import logo from './logo.svg';
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <p>
          Welcome to Wildlife Xtreme
        </p>
        <div>
          <a
            className="App-link"
            href="https://www.instagram.com/wildlife_xtreme/?hl=en"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaInstagram />
          </a>
        </div>
      </header>
    </div>
  );
}

export default App;
